import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import * as ACCOUNT_ADMIN_API from '../../constants/api/account-admin.constants';
import {
    IAccountAdminDAO,
    IAccountAdminDTO,
    IDataAnonymizationDTO,
    IThirdPartyRegistrationDTO,
    IRecurringZoomMeetingsDTO,
    IComplianceEmailDTO,
    IRegistrationApprovalDTO,
    ISegregatedDataEncryptionDTO,
    IAccountSubdomainDTO,
    IOrderBookingDTO,
    IOEPassportAuthenticationDTO,
    IURLParameterRegistrationDTO,
    IOEPassportAttendeeSSODTO,
    IAIAgentAccessDTO,
} from '../account-admin';
import { IPaginationParams } from '../shared.dto';

class AccountAdminDAO extends IAccountAdminDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccountAdmin(params: IPaginationParams): Promise<IAccountAdminDTO> {
        const response = await this.apiClient.get<IAccountAdminDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateDataAnonymization(params: IDataAnonymizationDTO): Promise<IDataAnonymizationDTO> {
        const response = await this.apiClient.put<IDataAnonymizationDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateThirdPartyRegistrationData(params: IThirdPartyRegistrationDTO): Promise<IThirdPartyRegistrationDTO> {
        const response = await this.apiClient.put<IThirdPartyRegistrationDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateRecurringZoomMeetingsData(params: IRecurringZoomMeetingsDTO): Promise<IRecurringZoomMeetingsDTO> {
        const response = await this.apiClient.put<IRecurringZoomMeetingsDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateComplianceEmailsData(params: IComplianceEmailDTO): Promise<IComplianceEmailDTO> {
        const response = await this.apiClient.put<IComplianceEmailDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateRegistrationApprovalData(params: IRegistrationApprovalDTO): Promise<IRegistrationApprovalDTO> {
        const response = await this.apiClient.put<IRegistrationApprovalDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateOrderBookingData(params: IOrderBookingDTO): Promise<IOrderBookingDTO> {
        const response = await this.apiClient.put<IOrderBookingDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateSegregatedDataEncryptionData(params: ISegregatedDataEncryptionDTO): Promise<ISegregatedDataEncryptionDTO> {
        const response = await this.apiClient.put<ISegregatedDataEncryptionDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateAccountSubdomainData(params: IAccountSubdomainDTO): Promise<IAccountSubdomainDTO> {
        const response = await this.apiClient.put<IAccountSubdomainDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateOEPassportAuthenticationData(params: IOEPassportAuthenticationDTO): Promise<IOEPassportAuthenticationDTO> {
        const response = await this.apiClient.put<IOEPassportAuthenticationDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateURLParameterRegistrationData(params: IURLParameterRegistrationDTO): Promise<IURLParameterRegistrationDTO> {
        const response = await this.apiClient.put<IURLParameterRegistrationDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateOEPassportAttendeeSSOData(params: IOEPassportAttendeeSSODTO): Promise<IOEPassportAttendeeSSODTO> {
        const response = await this.apiClient.put<IOEPassportAttendeeSSODTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }

    public async updateAIAgentAccessData(params: IAIAgentAccessDTO): Promise<IAIAgentAccessDTO> {
        const response = await this.apiClient.put<IAIAgentAccessDTO>(ACCOUNT_ADMIN_API.ACCOUNT_ADMIN_URL, params || {});
        return response.parsedResponse;
    }
}


export { AccountAdminDAO };
